import styled from 'styled-components';
import Icon from 'gatsby-theme-core/src/components/form-elements/radio/icon';

export default styled(Icon)`
  background-color: ${({ theme }) => theme.backgroundColor};
  border: 1px solid ${({ theme }) => theme.grayLightColor};
`;
